import {promotionsCredit} from "@img"

function Promotions() {
    return (
        <div className="sidebar-inner flex flex-col items-center justify-center min-h-[60vh] text-center relative">
            <img src={promotionsCredit} alt="car"/>
            <div className="absolute inset-0 bg-white/70 backdrop-blur-sm"></div>
            <h2 className="absolute inset-0 z-10 flex items-center justify-center text-4xl font-bold text-(--text-primary)">Coming Soon</h2>
        </div>
    )
}

export default Promotions
